<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid" v-if="dataReady">
				<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>

				<div class="pull-right">
					<button type="button" class="btn btn-info" data-toggle="modal" data-target="#borrowModal" title="Заеми" v-if="canBorrow">
						<i class="fa fa-book"></i>Заеми
					</button>
					<router-link data-toggle="tooltip" title="Назад" class="btn btn-default" to="/book/list"><i class="fa fa-arrow-left"></i></router-link>
					<router-link data-toggle="tooltip" title="Редактирай" class="btn btn-info" :to="'/book/' + book.id + '/edit'" v-if="isOwner"><i class="fa fa-pencil"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">
		<div class="card">
			<div class="card-header clearfix">
				<h4 class="card-title pull-left">
					<img :src="book.image || '/network/static/img/default.jpg'" style="width: 40px; margin-right: 1rem">
					{{ book.title }}
				</h4>
				<!-- <a :href="book.link" class="btn btn-primary btn-icon pull-right" target="_blank"><i class="fa fa-file-text"></i> Отвори</a> -->
			</div>
			<div class="card-block">
				<div class="table-responsive">
					<table class="table">
						<tbody>
							<tr>
									<td class="w-25">Автор:</td>
									<td>
										{{ book.author }}
									</td>
							</tr>
							<tr>
									<td>Издателство:</td>
									<td>
										{{ book.publisher }}
									</td>
							</tr>
							<tr>
									<td>Описание:</td>
									<td>
										<p v-html="$options.filters.nl2br(book.description)"></p>
									</td>
							</tr>
							<tr>
									<td>Език:</td>
									<td>
										{{ $config.lists.languages[book.language].text }}
									</td>
							</tr>
							<tr>
									<td>Статус:</td>
									<td>
										<div class="clearfix">
										<span class="float-left" style="padding-top: 20px;">{{ $config.lists.bookStatuses[book.status].text }}</span>

										<div v-if="isStatusChangeable">
											<button type="button" class="btn btn-info" data-toggle="modal" data-target="#changeModal"><i class="fa fa-book"></i> Промени</button>
										</div>
										</div>
									</td>
							</tr>
							<tr>
									<td>Принадлежи на семейство:</td>
									<td>
										<div class="clearfix">
											<c-avatar :family="book.family" :show-name="true" class="float-left"></c-avatar>
										</div>
									</td>
							</tr>
							<tr v-if="book.status=='requested' && book.taker">
									<td>Поискана от семейство:<br><span>(до {{ book.takerDueDate | prettyDate }})</span></td>
									<td>
										<div class="clearfix">
											<c-avatar :family="book.taker" :show-name="true" class="float-left"></c-avatar>

											<div v-if="isRequested">
												<button type="button" class="btn btn-success" data-toggle="tooltip" title="Одобрявам" @click="onApproveRequest()"><i class="fa fa-check"></i> Одобрявам</button>
												<button type="button" class="btn btn-danger" data-toggle="tooltip" title="Не одобрявам" @click="onRejectRequest()"><i class="fa fa-close"></i> Не одобрявам</button>
											</div>
										</div>
									</td>
							</tr>
							<tr v-if="book.status=='taken'">
									<td>Дадена на семейство:<br><span>(до {{ book.takerDueDate | prettyDate }})</span></td>
									<td>
										<div class="clearfix" v-if="book.taker">
											<c-avatar :family="book.taker" :show-name="true" class="float-left"></c-avatar>
										</div>
										<div v-else>
											{{ book.takerExternal }}
										</div>
									</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div><!--	end card	-->

		<f-modal id="borrowModal" :large="true" cancel-text="Отказ" @ok="onBorrowBook">
			<h5 slot="title">Поискване на книга</h5>
			<div slot="modal-body" class="modal-body">
				<div class="row">
					<div class="col-md-12">
				<p>Период, за който искате да използвате тази книга:</p>
				<div>
					<f-radio v-model="borrowPeriod" name="borrowPeriod" :radios="$config.lists.borrowPeriods" v-validate="'required'"></f-radio>
				</div>
				</div>
				</div>
				<div class="row">
					<div class="col-md-12" style="margin-top: 10px;">
				<p class="alert alert-warning">Семейството, което притежава книгата може да одобри или отхвърли заявката.<br>При одобрение двете семейства трябва да се разберат допълнително за самото изпращане на книгата.</p>
			</div>
			</div>
			</div>
		</f-modal>

		<f-modal id="changeModal" :large="true" cancel-text="Отказ" @ok="onChangeStatus">
			<h5 slot="title">Промяна на статуса на книгата</h5>
			<div slot="modal-body" class="modal-body">

				<div class="row">
					<div class="col-md-12">
					<p>
						<f-select v-model="bookStatus" name="book_status" v-validate="'required'" :errors="errorBag.collect('book_status')" :values="$config.lists.bookStatuses">
					</f-select>
					</p>
					</div>
				</div>
				<div class="row" v-if="bookStatus === 'taken'">
					<div class="col-md-12">
					<div>
						<f-radio v-model="takerType" name="takerType" :radios="takerTypes"></f-radio>
					</div>
					</div>

					<div class="col-md-12">
						<div v-if="takerType == 1">
							<f-family v-model="takerInternal" cplaceholder="Въведете име на семейство от мрежата"></f-family>
						</div>
						<div v-else>
							<f-input v-model="takerExternal" cplaceholder="Въведете име"></f-input>
						</div>
					</div>
				</div>
				<div v-if="bookStatus === 'taken'">
					Период, за който искате да дадете книгата:
					<div>
						<f-radio v-model="borrowPeriod" name="borrowPeriod" :radios="$config.lists.borrowPeriods" v-validate="'required'"></f-radio>
					</div>
				</div>
			</div>
		</f-modal>


	</div>
</div>
</template>

<script>

module.exports = {
	data: function () {
		return {
			dataReady: false,
			borrowPeriod: 3,
			takerType: 1,
			takerTypes: [
				{value: 1, label: 'при семейство от Семейна образователна мрежа'},
				{value: 2, label: 'при семейство извън мрежата'},
			],
			takerExternal: '',
			takerInternal: undefined,
			bookStatus: '',
			book: {}
		};
	},
	created: function () {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	computed: {
		isOwner: function () {
			if (!this.book.family) return false;
			return this.book.family.id + '' === this.$user.familyUser.family.id + '';
		},
		canBorrow: function () {
			if (!this.book.family) return false;
			return (this.book.family.id + '' !== this.$user.familyUser.family.id + '') &&
						(this.book.status === 'available');
		},
		isRequested: function () {
			return this.isOwner && (this.book.status === 'requested');
		},
		isStatusChangeable: function () {
			return this.isOwner && (this.book.status !== 'requested');
		}
	},
	methods: {
		fetchData: function () {
			this.$http.get('backend://book/' + this.$route.params.id).then((result) => {
				if (!result.body.error) {
					this.book = result.body;
					this.bookStatus = this.book.status;
					if (this.book.status === 'taken') {
						if (this.book.takerExternal !== undefined) {
							this.takerExternal = this.book.takerExternal;
							this.takerType = 2;
						} else {
							this.takerInternal = this.book.taker;
							this.takerType = 1;
						}
					}
					this.dataReady = true;
				}
			}).catch(this.$http.toastCatcher);
		},
		onBorrowBook: function () {
			this.book.borrowPeriod = this.borrowPeriod;
			this.$http.post('backend://book/' + this.book.id + '/request', this.book).then((response) => {
				if (response.body.ok) {
					this.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
					this.book.status = 'requested';
				}
			}).catch(this.$http.toastCatcher);
		},
		onChangeStatus: function () {
			let payload = {
				status: this.bookStatus
			};
			if (this.bookStatus === 'taken') {
				if (this.takerType === 1) {
					if (this.takerInternal === undefined || this.takerInternal.id === 0) {
						alert('Моля, въведете семейството, което ще заеме книгата!');
						return;
					}	else {
						payload.takerInternal = this.takerInternal.id;
					}
				} else {
					if (this.takerExternal === '') {
						alert('Моля, въведете семейството, което ще заеме книгата!');
						return;
					} else {
						payload.takerExternal = this.takerExternal;
					}
				}
				payload.borrowPeriod = this.borrowPeriod;
			}
			this.$http.put('backend://book/' + this.book.id + '/status', payload).then((response) => {
				this.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		},
		onApproveRequest: function (status) {
			if (!confirm('Сигурни ли сте че искате да дадете тази книга?')) {
				return;
			}

			this.$http.post('backend://book/' + this.book.id + '/request/accept').then((response) => {
				this.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				this.book.status = 'taken';
			}).catch(this.$http.toastCatcher);
		},
		onRejectRequest: function () {
			if (!confirm('Сигурни ли сте че не одобрявате даването на тази книга?')) {
				return;
			}
			var comment = prompt('Моля, дайте причина за вашето неодобрение:');

			this.$http.post('backend://book/' + this.book.id + '/request/reject', {statusComment: comment}).then((response) => {
				this.$toasted.show('Заявката е изпратена успешно!').goAway(3000);
				this.book.status = 'available';
			}).catch(this.$http.toastCatcher);
		}
	}
};

</script>
<style>

</style>



// WEBPACK FOOTER //
// BookView.vue?40df46f6